module.exports = __webpack_public_path__ + "static/media/au-ns.837c7246.svg";